import classNames from 'classnames';
import fieldInputCss from '#components/form/field-input/assets/field-input.module.scss';
import { FieldInputVariant } from '#components/form';

const buildFiledInputVariantClassName = (variant: FieldInputVariant): string => classNames(
  { [fieldInputCss.fieldInput_lightGray34Percent]: variant === FieldInputVariant.lightGray34Percent },
  { [fieldInputCss.fieldInput_dark80Percent]: variant === FieldInputVariant.dark80Percent },
  { [fieldInputCss.fieldInput_dark]: variant === FieldInputVariant.dark },
  { [fieldInputCss.fieldInput_white]: variant === FieldInputVariant.white },
  { [fieldInputCss.fieldInput_wispPink]: variant === FieldInputVariant.wispPink },
  { [fieldInputCss.fieldInput_delicatePink]: variant === FieldInputVariant.delicatePink },
);

export { buildFiledInputVariantClassName };
